import { OrgTransaction, PublicTransaction } from '~/types'
import { getBridgeReceipt } from '~/utils/bridgeReceipt'
import { parseTransactionMetadata } from '~/utils/parseTransactionMetadata'

export const useBridgeReceiptUrl = (
  transaction: OrgTransaction | PublicTransaction,
): string | null => {
  // only fetch url if the transaction has a bridge
  if (transaction.isMerkleTransaction) return null

  const transactionMetadata = parseTransactionMetadata(
    transaction.transactionMetadata,
  )

  if (!transactionMetadata.bridgeData) return null

  return getBridgeReceipt(transactionMetadata.bridgeData)?.url ?? null
}
